import React, { useState, useEffect } from 'react';
import api from "../../../../../services/api";
import {
    Empresa
} from "../../../../../entities/Common";

import { Container } from './styles';
//@ts-ignore
import Select2 from "react-select2-wrapper";
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    FormGroup,
    Form,
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Modal,
    Row,
    Col,
    Spinner,
    PopoverBody,
    UncontrolledPopover
} from "reactstrap";


interface INew {
    empresa?: Empresa,
    onHidde(): void,
    onSuccess(): void
    show: boolean,
    notify(type: string, msg: string): void
}

interface Error {
    nome?: string,
    aplicacao?: string
}

const New: React.FC<INew> = ({
    empresa,
    onHidde,
    onSuccess,
    show,
    notify
}) => {

    const [nome, setNome] = useState('')
    const [aplicacao, setAplicacao] = useState('')
    const [saving, setSaving] = useState(false)

    const [error, setError] = useState({} as Error)

    useEffect(() => {
        setError({} as Error)
        setNome('')
        setAplicacao('')
    }, [show])

    async function handleSave(e: React.MouseEvent) {
        e.preventDefault()
        setError({} as Error)
        try {
            setSaving(true)
            await api.post(`common/empresas/${empresa?.id}/checagens`, {
                nome,
                aplicacao
            })
            notify('success', 'Motivo adicionado')
            onHidde()
            onSuccess()
        } catch (error) {
            notify('danger', 'Não conseguimos adicionar este motivo')
            const response = error.response
            if (response && response.status === 400 && response.data) {
                const messages = await response.data
                const errorMessage = {} as any
                for (let msg of messages) {
                    errorMessage[msg.field as string] = msg.message
                }
                setError(errorMessage)

            }
        } finally {
            setSaving(false)
        }
    }

    return (
        <Modal
            className="modal-dialog-centered"
            isOpen={show}
            toggle={onHidde}
        >
            <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                    Novo Motivo de Checagem
          </h5>
                <button
                    aria-label="Close"
                    className="close"
                    data-dismiss="modal"
                    type="button"
                    onClick={onHidde}
                >
                    <span aria-hidden={true}>×</span>
                </button>
            </div>
            <div className="modal-body">
                <Container>
                    <Row>
                        <Col>
                            <FormGroup>
                                <legend className="w-auto">
                                    <label className="form-control-label" >
                                        Nome*
                                    </label>
                                </legend>
                                <Input
                                    placeholder='Nome...'
                                    className="form-control"
                                    value={nome}
                                    onChange={e => setNome(e.target.value)}
                                />
                                <small className="text-danger">
                                    {error.nome || ""}
                                </small>
                            </FormGroup>
                        </Col>
                        <Col className='col-12' >
                            <FormGroup>
                                <legend className="w-auto">
                                    <label className="form-control-label" >
                                        Aplicação*
                                        <Button
                                            id='help-aplicacao'
                                            size='sm'
                                            color='link'>
                                            ?
                                        </Button>
                                        <UncontrolledPopover
                                            placement="top"
                                            target="help-aplicacao"
                                        >
                                            <PopoverBody>
                                                Informe quando o motivo da checagem deve ser exibido.<br />
                                                Ao selecionar <b>Em aberto</b>, o motivo será exibido como ponto de checagem para oportunidades abertas.<br />
                                                Ao selecionar <b>Encerramento</b>, o motivo será exibido como motivo de encerramento da oportuniade.<br />
                                                Ao selecionar <b>Em aberto e encerramento</b> o motivo será exibido em ambas as situações.<br />
                                            </PopoverBody>
                                        </UncontrolledPopover>
                                    </label>
                                </legend>
                                <Select2
                                    className="form-control"
                                    //@ts-ignore
                                    onSelect={(e) => setAplicacao(e.target.value)}
                                    value={aplicacao}
                                    data={[
                                        { id: 'encerramento', text: 'Encerramento' },
                                        { id: 'abertura', text: 'Em aberto' },
                                        { id: 'null', text: 'Em aberto e encerramento' }
                                    ]}
                                />
                                <small className="text-danger">
                                    {error.aplicacao || ""}
                                </small>
                            </FormGroup>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div className="modal-footer">
                <Button
                    color="link"
                    type="button"
                    disabled={saving}
                    onClick={onHidde}
                >
                    Voltar
                    </Button>
                <Button
                    color="primary"
                    type="button"
                    disabled={saving}
                    onClick={handleSave}
                >
                    {
                        saving &&
                        <Spinner
                            color='secondary'
                            size='sm'
                            className='mr-2'
                        />
                    }
                    {`Salvar e Adicionar a Empresa`}
                </Button>
            </div>
        </Modal>
    )
}

export default New;